// const serverPath = 'https://sitecenter.renhegroup.net/website-api/'
const serverPath = 'https://mancenter.renhegroup.net/website-api/'
// const serverPath = 'https://mancenter.renhegroup.net/website-api-test/'
// const serverPath = '192.168.100.6:8900';
// const serverPath = 'http://192.168.50.29:8900/website-api/'
const serverPiC = 'hunshui.xxcf.net/public'

export default {
  serverPath,
  serverPiC
}



// WEBPACK FOOTER //
// ./src/assets/js/serverPath.js